const model = {
  ROLE_USER: 1,
  ROLE_MANAGER: 30,
  ROLE_ADMIN: 100,
  ROLE_SHIPNETWORK: 400,
  ROLE_SUPERADMIN: 500,

};

export default model;
